export default __webpack_public_path__ + "static/media/image.onlineaccounting-lk.0537e1a4.png";